import React, { useEffect, useState } from 'react';
import { io } from 'socket.io-client';
import axios from 'axios';
import ChatWindow from './ChatWindow';
import { MessageInput } from './MessageInput';
import { isEmpty, map } from 'lodash';
import { Box } from '@mui/material';
import socket from './socket';

export default function CUChat() {
  // const [socket, setSocket] = useState();
  const [messages, setMessages] = useState([]);
  const [receivers, setReceivers] = useState([]);
  const [unreadCount, setUnreadCount] = useState(0);
  const user = {
    id: parseInt(localStorage?.getItem('user_id')),
    user_name: localStorage?.getItem('user_name'),
    event_id: parseInt(localStorage?.getItem('event_id')),
    gps_unit_name: localStorage?.getItem('gps_unit_name'),
  };

  // // 1️⃣ Load initial messages
  // useEffect(() => {
  //   if (!user) return;

  //   // 1. Fetch messages for the user
  //   axios
  //     .get(
  //       `${process.env.REACT_APP_API_URL}/messages/messages/${user?.event_id}/cu/${user.id}`
  //     )
  //     .then((res) =>
  //       setMessages(
  //         map(res.data, (msg) => {
  //           return {
  //             ...msg,
  //             msg_sender:
  //               msg.sender_id === parseInt(user.id) ? user?.gps_unit_name : 'C',
  //           };
  //         })
  //       )
  //     )
  //     .catch((err) => console.error('Failed to fetch messages:', err));

  //   axios
  //     .get(`${process.env.REACT_APP_API_URL}/messages/getscusers`)
  //     .then((res) => setReceivers(res.data))
  //     .catch((err) => console.error('Failed to fetch messages:', err));

  //   // 2. Initialize socket connection
  //   // const s = io(SOCKET_URL, { query: { user_id: user.id } });
  //   // setSocket(s);

  //   // Optional: Listen for new messages
  //   socket.on('new_message', (msg) => {
  //     setMessages((prev) =>
  //       map([...prev, msg], (msg) => {
  //         return {
  //           ...msg,
  //           msg_sender:
  //             msg.sender_id === parseInt(user.id) ? user?.gps_unit_name : 'C',
  //         };
  //       })
  //     );
  //   });

  //   // Cleanup on unmount or user change
  //   return () => {
  //     socket.disconnect();
  //   };
  // }, [user?.id]);

  // // 2️⃣ Socket events
  // useEffect(() => {
  //   if (!socket) return;

  //   socket.emit('join', { user_id: user.id });

  //   socket.on('connect', () => console.log('✅ Connected:', socket.id));

  //   // socket.on('new_message', (msg) => {
  //   //   if (msg.receivers.includes(user.id)) {
  //   //     setMessages((prev) => [...prev, msg]);
  //   //   }
  //   // });

  //   socket.on('new_message', (msg) => {
  //     setMessages((prev) =>
  //       map([...prev, msg], (msg) => {
  //         return {
  //           ...msg,
  //           msg_sender:
  //             msg.sender_id === parseInt(user.id) ? user?.gps_unit_name : 'C',
  //         };
  //       })
  //     );
  //   });

  //   socket.on('unread_counts', (counts) => {
  //     console.log('counts in cu chat', counts);
  //     setUnreadCount(counts.unread_from_sc || 0);
  //   });

  //   // socket.on('message_read', (data) => {
  //   //   setMessages((prev) =>
  //   //     prev.map((m) =>
  //   //       m.id === data.message_id
  //   //         ? { ...m, read: true, read_at: data.read_at }
  //   //         : m
  //   //     )
  //   //   );
  //   // });

  //   socket.emit('read_messages', { user_id: user.id });

  //   socket.on('message_read', (data) => {
  //     setMessages((prev) =>
  //       prev?.map((m) =>
  //         data?.message_ids?.includes(m.id)
  //           ? { ...m, read_at: data.read_at || new Date().toISOString() }
  //           : m
  //       )
  //     );
  //   });

  //   socket.on('disconnect', (reason) =>
  //     console.log('❌ Disconnected:', reason)
  //   );
  //   socket.on('connect_error', (err) =>
  //     console.error('Socket connect error:', err)
  //   );

  //   return () => {
  //     socket.emit('leave', { user_id: user.id });
  //   };
  // }, [user?.id]);

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_API_URL}/messages/getscusers`)
      .then((res) => setReceivers(res.data))
      .catch((err) => console.error('Failed to fetch messages:', err));
  }, []);

  useEffect(() => {
    socket.connect();
    socket.emit('join', { user_id: user?.id });

    socket.on('new_message', (msg) => {
      setMessages((prev) =>
        map([...prev, msg], (msg) => {
          return {
            ...msg,
            msg_sender:
              msg.sender_id === parseInt(user.id) ? user?.gps_unit_name : 'C',
          };
        })
      );
    });

    // socket.on("new_message", (msg) => {
    //     setMessages(prev => {
    //         // if already exists, don't add again
    //         if (prev.some(msg => msg.id === msg.id)) {
    //             return prev;
    //         }
    //         return [...prev, msg];
    //     });
    // });

    socket.on('message_read', (payload) => {
      setMessages((prev) =>
        prev.map((m) => {
          if (m.id === payload.message_id) {
            return {
              ...m,
              msg_sender:
                m.sender_id === parseInt(user.id) ? user?.gps_unit_name : 'C',
              reads: m?.reads?.map((r) =>
                r.receiver_id === payload.reader_id
                  ? { ...r, read: true, read_at: payload.read_at }
                  : r
              ),
            };
          }
          return m;
        })
      );
    });

    return () => socket.disconnect();
  }, []);

  console.log('receivers', receivers);

  const fetchMessages = (eventId, role, userId, cuIds = null) => {
    let url = `${process.env.REACT_APP_API_URL}/messages/messages/${eventId}/${role}/${userId}/${receivers[0]?.id}`;
    if (cuIds) url += `/${cuIds.join(',')}`;
    return axios.get(url).then((res) =>
      map(res?.data, (msg) => {
        return {
          ...msg,
          msg_sender:
            msg.sender_id === parseInt(user.id) ? user?.gps_unit_name : 'C',
        };
      })
    );
  };

  useEffect(() => {
    if (receivers[0]?.id) {
      console.log("receivers[0]?.id",receivers[0]?.id);
      
      fetchMessages(user?.event_id, 'cu', user?.id).then(setMessages);
    }
  }, [receivers[0]?.id]);

  const markRead = (messageIds) => {
    socket.emit('read_messages', {
      receiver_id: user?.id,
      message_ids: messageIds,
    });
  };

  // const sendMessage = (content) => {
  //   socket.emit('send_message', {
  //     event_id: user?.event_id,
  //     sender_id: user?.id,
  //     content,
  //   });
  // };

  // 3️⃣ Send message
  const sendMessage = async (data) => {
    // await axios.post(
    //   `${process.env.REACT_APP_API_URL}/messages/sendmessage/${user?.event_id}`,
    //   {
    //     sender_id: user.id,
    //     content: data?.text,
    //     emcode: data?.dropdown1,
    //     emaction: data?.dropdown2,
    //     emlocation: data?.dropdown3,
    //     attachment_url: !isEmpty(data?.attachments)
    //       ? JSON.stringify(data?.attachments)
    //       : '',
    //     receiver_ids: map(receivers, 'id'),
    //     // created_at: new Date().toISOString(),
    //   }
    // );

    socket.emit('send_message', {
      event_id: user?.event_id,
      sender_id: user.id,
      content: data?.text,
      receiver_ids: map(receivers, 'id'),
      emcode: data?.dropdown1,
      emaction: data?.dropdown2,
      emlocation: data?.dropdown3,
      attachment_url: !isEmpty(data?.attachments)
        ? JSON.stringify(data?.attachments)
        : '',
    });
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        flex: 1,
        borderLeft: '1px solid #ddd',
        height: '100%', // make sure the parent has height
      }}
    >
      {/* Chat window */}
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          flex: 1,
          overflow: 'hidden', // hide overflow in wrapper
        }}
      >
        <ChatWindow
          messages={messages}
          cuId={user.id}
          selectedUser={'CONTROL ROOM'}
          isAmbulanceTracker={true}
        />
      </Box>

      {/* Message input fixed at bottom */}
      <Box sx={{ flexShrink: 0 }}>
        <MessageInput onSend={sendMessage} disabled={false} isCuChat={true}/>
      </Box>
    </Box>
  );
}
